import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Download14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.4697 5.46967L7.75 8.18939L7.75 1H6.25L6.25 8.18928L3.53039 5.46967L2.46973 6.53033L7.00006 11.0607L11.5304 6.53033L10.4697 5.46967Z'
      fill='currentColor'
    />
    <path d='M12 12.25H2V13.75H12V12.25Z' fill='currentColor' />
  </Svg>
);

Download14.displayName = 'Download14';
export default Download14;
